/*
  Currently using Rollup to bundle up this script for distribution. https://rollupjs.org/guide/en/

  Installation: npm install --global rollup
  Command to bundle (run in folder containing this file): rollup publication-quartet.js --file ../dist/publication-quartet.js --format iife --sourcemap
*/

(function ($) {
  // Ensure googletag object is available
  window.googletag = window.googletag || { cmd: [] };

  // Get reference  to loading spinner element
  const spinner = $(".loading-spinner-wrapper");

  let pageCount = 0; // Pagination
  let canFetch = false; // Used as latch to prevent firing script repeatedly

  function fetchPosts() {
    canFetch = false;
    spinner.show();

    // Query this page via GET to recieve publication-specific posts
    $.ajax({
      type: "GET",
      url: exmloadmore.url,
      data: {
        action: "exm_infinite_scroll",
        publication_page: pageCount + 1,
        query: exmloadmore.query,
      },
      success: function (res) {
        try {
          // If response was empty, check to see if this was intentional. If so, stop here and prevent any further calls
          if (res === "<!-- No more posts -->") {
            $("<div/>", {
              class: "container",
              text: "No more posts to display",
            }).appendTo("#infinite-scroll-container");
            $(window).off("scroll.loadInfiniteContent");
            return;
          }

          // Get infinite content from response, and append it to #infinite-scroll-container
          const pulledStories = $(res).filter("#infinite-scroll-content");
          $("#infinite-scroll-container").append(pulledStories);

          // Finally, increase the page count once everything is completed
          pageCount++;

        } catch (error) {
          console.error(error);
        } finally {
          canFetch = true;
          spinner.hide();
        }
      },
    });
  }

  $("document").ready(function () {
    canFetch = true;
    spinner.hide();

    // Fire event if user scrolls to bottom of page
    $(window).on("scroll.loadInfiniteContent", function () {
      // Overriding bug caused by zoomed in Chromium users
      // see: https://stackoverflow.com/questions/30320512/code-on-scroll-event-is-not-executing-if-window-is-zoomed-in-out-in-chrome
      const scrollTop = $(window).scrollTop(),
        windowHeight = $(window).height(),
        documentHeight = $(document).height();

      if (
        canFetch &&
        scrollTop > 0 &&
        Math.ceil(scrollTop + windowHeight) >= documentHeight
      ) {
        fetchPosts();
      }
    });
  });
})(jQuery);
